import { useQuery, useSuspenseQuery } from '@tanstack/react-query';

import { MyRobotManager, MyRobotUrls } from './MyRobotManager';

const queryKey = [MyRobotUrls.PrimaryInformation.url];

export function useAllRobotPrimaryInformation() {
  const {
    data: allRobotsPrimaryInformation,
    refetch: refreshRobots,
    isRefetching: isRefreshing,
  } = useSuspenseQuery({
    queryKey,
    queryFn: MyRobotManager.getAllRobotPrimaryInformation,
  });

  return { allRobotsPrimaryInformation, refreshRobots, isRefreshing };
}
